import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { PurchasesResponse } from "@/api/types/paymentGateway";
import { queryKeys } from "@/lib/queryClient";
import { getPurchases } from "@/api/endpoints/paymentGateway";

type GetPurchasesQueryKey = ReturnType<
  typeof queryKeys.paymentGateway.purchases
>;

type UseGetPurchasesOptions = Omit<
  UseQueryOptions<
    PurchasesResponse,
    Error,
    PurchasesResponse,
    GetPurchasesQueryKey
  >,
  "queryKey" | "queryFn"
>;

export function useGetPurchases(config?: UseGetPurchasesOptions) {
  return useQuery<
    PurchasesResponse,
    Error,
    PurchasesResponse,
    GetPurchasesQueryKey
  >({
    queryKey: queryKeys.paymentGateway.purchases(),
    queryFn: getPurchases,
    staleTime: 60 * 1000,
    ...config,
  });
}
